var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 27,
    viewBox: "0 0 48 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.508 9.74804L21.4867 9.72055L21.4241 25.7059L28.4454 25.7334L28.508 9.74804Z",
    fill: "#1C1D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8678 2.67364L10.8467 2.64615L10.7564 25.7112L17.7775 25.7387L17.8678 2.67364Z",
    fill: "#1C1D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0453 0.652017C22.9563 0.643838 21.2565 2.23929 21.2489 4.18297C21.2413 6.12665 22.916 7.77062 25.0174 7.77884C27.0817 7.78693 28.7692 6.19147 28.7769 4.21244C28.7847 2.23342 27.0973 0.660052 25.0453 0.652017Z",
    fill: "#1C1D38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8825 22.1067L40.9037 16.6997C38.269 17.137 37.2483 18.9589 37.2408 20.879C37.234 22.6107 37.8723 23.7912 39.1578 23.7963C40.4434 23.8013 40.8796 22.8488 40.8825 22.1067ZM47.9294 15.6081L47.887 26.4456L47.0462 26.4423L41.227 22.5439C41.0217 24.4632 39.0245 26.246 35.9095 26.2338C32.7945 26.2216 30.7851 24.8354 30.7967 21.8905C30.8097 18.5685 33.9581 16.3426 40.9177 16.2992L40.9315 12.7535C40.9367 11.4459 40.7458 9.74879 38.7185 9.74085C36.6913 9.73291 34.2495 11.4197 32.7604 12.8864L32.7699 10.4597C34.9608 9.70258 37.8425 9.30156 39.5236 9.30815C45.1603 9.33022 47.9612 10.6488 47.9418 15.6081L47.9294 15.6081Z",
    fill: "#1C1D38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12322 9.66432L0.0650635 9.63669L0.0024739 25.622L7.06063 25.6497L7.12322 9.66432Z",
    fill: "#1C1D38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66485 2.61803L11.6377 2.64925L11.636 3.09689L2.2569 8.65571L1.7499 8.65372L3.66485 2.61803Z",
    fill: "#4AC8F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e2294124aaf2c8010496ccb5094c3c0.svg";
export { ForwardRef as ReactComponent };